import './Menu.css'
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Nav, Navbar } from 'react-bootstrap'
import { MenuItem } from 'components'
import { getErrors } from 'core/helpers'
import { IRootState, INotPagedData } from 'types'
import { V1ApiUsersClient } from 'core/http-common'
import { MenuItemDto } from '@v1UsersApi'

const Menu = () => {
  const authenticated = useSelector((state: IRootState) => state.user.authenticated)
  const multiFactorLoginEnabled = useSelector((state: IRootState) => state.user.multiFactorLoginEnabled)
  const multiFactorConfirmed = useSelector((state: IRootState) => state.user.multiFactorConfirmed)
  const routes = useSelector((state: IRootState) => state.app.routes)

  const [data, setData] = useState<INotPagedData<MenuItemDto>>({
    loaded: false,
    items: [],
    totalItems: 0,
    errors: []
  })

  useEffect(() => {
    async function fetchData() {
      if (authenticated && (multiFactorConfirmed || !multiFactorLoginEnabled)) {
        try {
          const response = await V1ApiUsersClient.getMenuItems()
          setData((prevState: INotPagedData<MenuItemDto>) => ({
            ...prevState,
            loaded: true,
            items: response.data,
            totalItems: response.totalItems,
            errors: []
          }))
        }
        catch (e) {

          setData((prevState: INotPagedData<MenuItemDto>) => ({
            ...prevState,
            loaded: true,
            errors: getErrors(e)
          }))
        }
      }
    }
    fetchData()
  }, [authenticated, multiFactorLoginEnabled, multiFactorConfirmed])

  if (!routes || routes.length === 0 || routes.find(r => r.route === location.pathname)?.hideHeader)
    return <></>

  return (
    <div id='NavBar' className='hidden-print'>
      {authenticated && (multiFactorConfirmed || !multiFactorLoginEnabled) ?
        <Navbar collapseOnSelect expand='xl' bg='light'>
          <span className='d-block d-xl-none navbar-brand'>Main Menu</span>
          <Navbar.Toggle aria-controls='responsive-navbar-nav' />

          <Navbar.Collapse>
            <Nav className='me-auto' as='ul'>
              {data.items.map((item: MenuItemDto) => (<MenuItem key={`${item.tabId.toString()}`} item={item} depth={1} />))}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        : <></>
      }
    </div>
  )
}

export default Menu